import ShareModelService from "@/services/insurancepricing/ShareModelService";
import ShareModelDescriptionService from "@/services/insurancepricing/ShareModelDescriptionService";

const shareModelService = new ShareModelService();
const shareModelDescriptionService = new ShareModelDescriptionService();

const state = {
  shareModels: [],
  shareModelDescriptions: [],
  shareModel: {},
  shareModelRevision: null,
  processed: false
};

const getters = {
    getShareModels(state) {
        return state.shareModels;
    },
    getShareModelDescriptions(state) {
      return state.shareModelDescriptions;
    },
    shareModelProcessed(state) {
        return state.processed;
    },
    getShareModel(state) {
      return state.shareModel;
    },
    shareModelRevision(state) {
      return state.shareModelRevision
    }
};

const actions = {
    fetchShareModels({commit}, params) {
        return new Promise((resolve, reject) => {
          shareModelService.findAllByParams(
                params
            )
                .then(response => {
                    commit("SET_SHARE_MODELS", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    createShareModelDescription({commit}, {id, shareModelDescription}) {
      return new Promise((resolve, reject) => {
        shareModelDescriptionService.save(id, shareModelDescription)
          .then(response => {
            commit("CREATED_SHARE_MODEL_DESCRIPTION", response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchShareModelDescriptions({commit}, id) {
      return new Promise((resolve, reject) => {
        shareModelDescriptionService.findAll(id)
          .then(response => {
            commit("SET_SHARE_MODEL_DESCRIPTIONS", response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchShareModel({commit}, id) {
        return new Promise((resolve, reject) => {
          shareModelService.get(id).then(response => {
                    commit("SET_SHARE_MODEL", response.data);
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
        });
    },
    fetchShareModelRevision({commit}, id) {
      return new Promise((resolve, reject) => {
        shareModelService.getRevision(
          id
        )
          .then(response => {
            commit("SET_SHARE_MODEL_REVISION", response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createShareModel({commit}, shareModel) {
        return new Promise((resolve, reject) => {
          shareModelService.save(shareModel)
                .then(response => {
                    commit("CREATED_SHARE_MODEL");
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updateShareModel({commit}, {id, shareModel}) {
        return new Promise((resolve, reject) => {
          shareModelService.update(id, shareModel)
                .then(response => {
                    commit("UPDATED_SHARE_MODEL");
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    deleteShareModel({commit}, id) {
        return new Promise((resolve, reject) => {
          shareModelService.delete(id)
                .then(response => {
                    commit("DELETED_SHARE_MODEL");
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};

const mutations = {
    SET_SHARE_MODEL_DESCRIPTIONS(state, data) {
      state.shareModelDescriptions = data;
      state.processed = false;
    },
    CREATED_SHARE_MODEL_DESCRIPTION(state, data) {
      state.shareModelDescriptions.push(data);
      state.processed = false;
    },
    SET_SHARE_MODELS(state, data) {
        state.shareModels= data;
        state.processed = false;
    },
    SET_SHARE_MODEL(state, data) {
        state.shareModel = data;
        state.processed = false;
    },
    SET_SHARE_MODEL_REVISION(state, data) {
      state.shareModelRevision = data;
      state.processed = false;
    },
    CREATED_SHARE_MODEL(state) {
        state.processed = true;
    },
    UPDATED_SHARE_MODEL(state) {
        state.processed = true;
    },
    DELETED_SHARE_MODEL(state) {
        state.processed = true;
    },
    CLEAR_SHARE_MODEL_DESCRIPTIONS(state) {
      state.shareModelDescriptions = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
